import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class CategoryAPI {

    URI_V1 = "/v1/categories"

    create = async (data: any) => {
        return await apiService.postFormData(`${this.URI_V1}`, data);
    };

    update = async (categoryId: any, data: any) => {
        return await apiService.putFormData(`${this.URI_V1}/${categoryId}`, data);
    };

    delete = async (categoryId: any) => {
        return await apiService.delete(`${this.URI_V1}/${categoryId}`);
    };

    findAllByCompanyId = async (companyId: any) => {
        return await apiService.get(`${this.URI_V1}/company/${companyId}`);
    };

    findAllByCompanyScheduler = async (companyId: any) => {
        return await apiService.get(`${this.URI_V1}/company/${companyId}/services-scheduler`);
    };


    getAllSuggestion = async () => {
        return await apiService.get(`${this.URI_V1}/suggestion?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    createBySuggestion = async (companyId: any, data: any) => {
        return await apiService.post(`${this.URI_V1}/suggestion?companyId=${companyId}`, data);
    };
}
